<template>
<div>
  <el-button v-if="modifiable" size="small" @click="$refs.slidingPopup.open()">추가</el-button>
  <w-sliding-popup ref="slidingPopup" title="보조 IP 추가" width="300px" @close="closePopup">
    <div slot="content">
      <span style="display:flex; justify-content:flex-end; margin-bottom:10px;">
        <el-button @click="addDomain" type="primary"><i class="fas fa-plus mr-r4"></i>추가</el-button>
      </span>
      <el-form :model="ipForm" ref="addIpForm">
         <div v-for="(field, index) in ipForm.subIpInfoList" :key="index" style="margin-bottom:20px;">
           <el-form-item :label="'IP 주소 ' + index" :rules="rules" :prop="'subIpInfoList.' + index + '.ipAddress'">
             <el-row :gutter="10">
               <el-col :span="20">
                 <el-input v-model="field.ipAddress"></el-input>
               </el-col>
               <el-col :span="4">
                 <el-button type="mini" @click.prevent="removeField(field)"><i class="fas fa-minus"></i></el-button>
               </el-col>
             </el-row>
           </el-form-item>
         </div>
      </el-form>
    </div>
    <el-row slot="footer" class="dialog-footer" type="flex" justify="center">
      <el-button size="large" class="mr-r4" type="solid" @click="saveStore">확인</el-button>
      <el-button size="large" @click="$refs.slidingPopup.close()">취소</el-button>
    </el-row>
  </w-sliding-popup>
</div>
</template>
<script>
import isNil from 'lodash/isNil';

export default {
  name: 'wSubipInfo',
  props: ['modifiable', 'subIpInfo', 'objId'],
  data() {
    return {
      showFlag: false,
      ipForm: {
        subIpInfoList: [],
      },
      rules: {
        pattern: '^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
        message: 'IPv4에 맞는 형식으로 입력해주세요.',
        trigger: 'blur',
      },
    };
  },
  computed: {},
  watch: {
    subIpInfo: {
      immediate: true,
      handler(to, from) {
        if (!isNil(this.subIpInfo) && this.subIpInfo.length > 0) {
          this.ipForm.subIpInfoList = this.subIpInfo.slice();
        } else {
          this.ipForm.subIpInfoList = [];
          this.ipForm.subIpInfoList.push({
            objId: this.objId,
            ipAddress: null,
          });
        }
      },
    },
  },
  methods: {
    closePopup() {
      // this.$refs.addIpForm.resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    saveStore() {
      const me = this;
      this.$refs.addIpForm.validate((valid) => {
        if (valid) {
          const ipList = this.ipForm.subIpInfoList;
          const updateList = [];
          ipList.forEach((ipField) => {
            if (!isNil(ipField.ipAddress) && !updateList.includes(ipField.ipAddress)) {
              updateList.push(ipField);
            }
          });
          this.$emit('updateSubIp', updateList);
          me.closePopup();
        } else {
          return false;
        }
      });
    },
    removeField(item) {
      if (this.ipForm.subIpInfoList.length > 1) {
        const index = this.ipForm.subIpInfoList.indexOf(item);
        if (index !== -1) {
          this.ipForm.subIpInfoList.splice(index, 1);
        }
      }
    },
    addDomain() {
      this.ipForm.subIpInfoList.push({
        objId: this.objId,
        ipAddress: null,
      });
    },
  },
};
</script>

<style>
.form-list .el-form-item__label {
  text-align: left;
  min-width: 100px;
}

/*
.form-header {
  padding-left: 10px;
  height: 25px;
  font-weight: bold;
  font-size: 14px;
  color: #8B8B8B;
} */
</style>



// WEBPACK FOOTER //
// src/views/config/node/netdevice/configstatus/components/subipInfo.vue